import React, { Component } from "react";
import { Link } from 'react-router';

class Tile extends Component {
    render() {

        const { mainClass, titleClass, title, children, btnClass, btnLink, btnText } = this.props;

        return (
            <div className={ mainClass }>
                { children }
                <h3 className={ titleClass }>{ title }</h3>
                <Link className={ btnClass } to={ `/${ btnLink }` }>
                    <span className="label">{ btnText && btnText }</span>
                    <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
                </Link>
            </div>
        )
    };
}

export default Tile;


// WEBPACK FOOTER //
// src/client/components/common/elements/Tile.js